import { createContext, FC, ReactNode, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthContext, UserSessionContext } from './AuthServiceProvider';

// eslint-disable-next-line import/no-unused-modules
export const TokenContext = createContext('token_context_not_initialized');

interface IProps {
      node: ReactNode;
}

const ProtectedRoutes: FC<{children: IProps}> = ({children}) => {

    const providedUser = useContext(UserSessionContext);
    const userManager = useContext(AuthContext);
    const location = useLocation();
    
    useEffect(
        () => {
            userManager.getUser().then(user => {
                if (!user || user.expired) {
                    sessionStorage.setItem('returnUrl', location.pathname);
                    userManager.signinRedirect();
                }
            });
        },
        [location.pathname, userManager],
    );

    //All pages that need authentication need to be added within the TokenContext Provider, this is passed as a react node parameter
    return (providedUser && !providedUser.expired)
        ? (
            <TokenContext.Provider value={providedUser.access_token}>
                {children.node}        
            </TokenContext.Provider>
        )
        : <label>Authenticating</label>

};

export default ProtectedRoutes;